import { isBefore, isValid, parseISO, startOfDay, subMonths } from 'date-fns';

const WHATS_NEW_VISIBLE_MONTHS = 3;

export const getRecentWhatsNewItems = <T extends { date: string }>(items: T[], now = new Date()): T[] => {
    const oldestVisibleDate = startOfDay(subMonths(now, WHATS_NEW_VISIBLE_MONTHS));

    return items.filter(item => {
        const itemDate = parseISO(item.date);
        return isValid(itemDate) && !isBefore(itemDate, oldestVisibleDate);
    });
};
